import {
  IP_CONTIGUOUS_RANGE_LONG,
  IP_CONTIGUOUS_RANGE_SHORT,
  IPSET_RANGE,
  IPSET_RANGE_CIDR,
} from './ip-regex/ip-regex';

export const isValidIp = (target: string) => {
  return (
    IPSET_RANGE_CIDR.test(target) ||
    IP_CONTIGUOUS_RANGE_LONG.test(target) ||
    IP_CONTIGUOUS_RANGE_SHORT.test(target) ||
    IPSET_RANGE.test(target)
  );
};

export const removeLeadingZerosFromIpOctets = (ip: string) =>
  ip.replace(/(\b0+)(?=\d)/g, '');
